import { createAsyncAction } from "typesafe-actions";
import SellingSpot from "../../models/selling/SellingSpot";
import { GetSellingSpotsActionTypes } from "./types";

export const getSellingSpotsActions = createAsyncAction(
    GetSellingSpotsActionTypes.REQUEST,
    GetSellingSpotsActionTypes.SUCCESS,
    GetSellingSpotsActionTypes.ERROR
)<undefined, SellingSpot[], undefined>();
